// Pure, DOM-free validators shared by TierConfigForm.vue and TierForm.vue.
// Kept out of the .vue files specifically so tests/unit/tierValidation.spec.ts
// can exercise them without a browser or component-mount harness (this repo's
// yarn test:unit runs under plain Node — see playwright.unit.config.ts).
//
// graceDays: 0 is a legitimate value ("downgrade immediately, no grace
// period") — mirrors the backend's own guard in
// dent-cloud-service/.../patientTierController/updateConfig.js, whose header
// comment explains it deliberately avoids src/utils/isEmpty.js there because
// THAT helper treats 0 as empty. All four validators below check `typeof
// value === "number"` rather than truthiness for exactly that reason: a
// falsy check (`!value`) would wrongly flag 0 as missing input for both
// graceDays and rank/windowMonths' lower bound. Do not "simplify" these back
// to a falsy check — see the spec file for the regression this guards.

export function windowMonthsError(value) {
  if (typeof value !== "number" || !Number.isInteger(value) || value < 1) {
    return "ช่วงเวลาคำนวณยอดสะสมต้องเป็นจำนวนเต็มตั้งแต่ 1 เดือนขึ้นไป";
  }
  return "";
}

export function graceDaysError(value) {
  if (typeof value !== "number" || !Number.isInteger(value) || value < 0) {
    return "จำนวนวันผ่อนผันต้องเป็นจำนวนเต็มตั้งแต่ 0 วันขึ้นไป (ใส่ 0 หากไม่ต้องการผ่อนผัน)";
  }
  return "";
}

export function rankError(value) {
  if (typeof value !== "number" || !Number.isInteger(value) || value < 1) {
    return "ลำดับระดับต้องเป็นจำนวนเต็มตั้งแต่ 1 ขึ้นไป";
  }
  return "";
}

export function thresholdAmountError(value) {
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
    return "ยอดขั้นต่ำต้องมากกว่า 0 บาท";
  }
  return "";
}
